import React, { useEffect, useRef } from "react";
import WebViewer from "@pdftron/webviewer";

export const FileViewer = ({
  initialDoc,
  onReady,
  style = { height: "100%", width: "100%" },
}) => {
  const viewerRef = useRef(null);

  useEffect(() => {
    WebViewer(
      {
        path: "/lib",
        initialDoc: "/sample_docs/A-100 - BASEMENT - GENERAL ARRANGEMENT PLAN.pdf",
        fullAPI: true,
        enableMeasurement: true, // ✅ enable measurement tools
      },
      viewerRef.current
    ).then((instance) => {
      const { docViewer, annotManager, UI } = instance;

      // Wait for viewer to load
      UI.addEventListener("viewerLoaded", () => {
        const toolManager = docViewer.getToolManager();

        // ✅ default tool to Pan
        toolManager.setToolMode("Pan");

        // ✅ show measurement tools in UI toolbar
        UI.enableElements(["measurementToolsButton"]);

        // ✅ load measurement module (if not auto)
        instance.Core.MeasurementManager.enableMeasurement();

        console.log("Measurement tools enabled ✅");
      });

      // expose custom helpers
      instance._custom = {
        setToolMode: (mode) => {
          try {
            const toolManager = docViewer.getToolManager();
            toolManager.setToolMode(mode);
          } catch (err) {
            console.warn("setToolMode failed:", err);
          }
        },
      };

      if (onReady) onReady(instance);
    });
  }, [initialDoc, onReady]);

  return (
    <div style={{ ...style, position: "relative" }}>
      <div ref={viewerRef} style={{ height: "100%", width: "100%" }} />
    </div>
  );
};

export default FileViewer;
